import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

export default function Layout() {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const getData = async () => {
    const user = sessionStorage;
    if (
      user.getItem("login_id") === "" ||
      user.getItem("login_id") == null
    ) {
      if (
        user.getItem("staff_login_id") === "" ||
        user.getItem("staff_login_id") == null
      ) {
        sessionStorage.clear();
        navigate("/business");
      } else {
        navigate("/DebitTransactions");
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="flex h-screen">
        <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="flex-1 overflow-y-auto bg-[#f5f6fa]">
          <Outlet />
        </div>
      </div>
    </>
  );
}